import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  paperDialog: {
    padding: '16px'
  }
}));
